import { Key, useState, useMemo, FC, } from 'react';
import { SwapOutlined } from '@ant-design/icons';
import SearchForm from '../../../SearchForm';
import { getFormItem } from '../../hooks/useSearchForm';
import { groupOptionsProps, SuperFormItemProps } from '../../interface';
import { SearchFormGroupProps } from '../../../SearchForm/group';
import { SearchFormItemEnum } from '../../../SearchForm/interface/baseInterface';

interface GruopFormItemProps {
  groupOptions: groupOptionsProps[];
  groupProps: SearchFormGroupProps;
  baseGroupProps: any;
  groupKey: string | number;
  defaultGroupOptionKey?: Key;
}
const GruopFormItem: FC<GruopFormItemProps> = (props) => {
  const { groupOptions, groupProps, baseGroupProps, groupKey, defaultGroupOptionKey, ...restProps } = props;
  const { label, ...restGroupProps } = groupProps;
  const [optionValue, setOptionValue] = useState<Key>(defaultGroupOptionKey || groupOptions[0].groupKey);
  const handleClick = () => {
    setOptionValue(prevOptionValue => {
      if (prevOptionValue === groupOptions[0].groupKey) return groupOptions[1].groupKey;
      return groupOptions[0].groupKey
    });
  };
  const renderNode = useMemo(() => {
    const findGroupOption = groupOptions.find(v => v.groupKey !== optionValue);
    return (
      <div className='yb-group-label'>
        <div>{label}</div>
        <div className='yb-group-label-button' onClick={handleClick}>
          <SwapOutlined className='yb-group-label-icon' />
          {findGroupOption?.label}
        </div>
      </div>
    );
  }, [label, optionValue]);
  const groupChildren = useMemo(() => {
    const findGroupOption = groupOptions.find(v => v.groupKey === optionValue);
    const children = findGroupOption?.children;
    if (Array.isArray(children)) {
      return children.map((item: SuperFormItemProps, index: number) => {
        return getFormItem({ ...restProps, ...baseGroupProps, ...item, }, `${groupKey}${index}`);
      });
    }
  }, [optionValue, baseGroupProps]);
  return (
    // @ts-ignore
    <SearchForm.Group label={renderNode} key={groupKey} groupOptions={groupOptions} form={restProps.form} {...restGroupProps}>
      {groupChildren}
    </SearchForm.Group>
  );
}

GruopFormItem.displayName = SearchFormItemEnum.SearchFormGroup;

export default GruopFormItem;
